import { FEATURE_FLAGS } from '@/constants';
export default {
  namespaced: true,
  state: () => ({
    [FEATURE_FLAGS]: localStorage.getItem(FEATURE_FLAGS) === 'true',
  }),
  getters: {
    isNewDesign: (state) => state[FEATURE_FLAGS],
  },
  mutations: {
    RESET_STATE(state) {
      state[FEATURE_FLAGS] = localStorage.getItem(FEATURE_FLAGS) === 'true';
    },
    SET_NEW_DESIGN(state, value) {
      state[FEATURE_FLAGS] = value === true;
      localStorage.setItem(FEATURE_FLAGS, JSON.stringify(state[FEATURE_FLAGS]));
    },
  },
  actions: {
    resetState({ commit }) {
      commit('RESET_STATE');
    },
    toggleNewDesign({ commit, state }) {
      commit('SET_NEW_DESIGN', !state[FEATURE_FLAGS]);
    },
  },
};
